"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "@opensea/navigation";
import { classNames } from "@opensea/ui-kit";
import { isSolanaAddress } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { EmptyStateStack } from "../empty-state/EmptyState";
import { useItemView } from "./ItemViewProvider";
import { ProfileItemsGridSkeleton } from "./profile/ProfileItemsGrid";
import { ProfileItemsTableSkeleton } from "./profile/ProfileItemsTable/ProfileItemsTableSkeleton";
export function ItemsEmptyState(t0) {
  const $ = _c(28);
  const {
    hasSearchParams,
    onResetFilters
  } = t0;
  const {
    itemViewGroup
  } = useItemView();
  const t = useTranslations("ItemsEmptyState");
  const pathname = usePathname();
  const isSolanaProfile = pathname.split("/").some(_temp);
  const Comp = itemViewGroup === "table" ? ProfileItemsTableSkeleton : ProfileItemsGridSkeleton;
  if (isSolanaProfile) {
    let t1;
    if ($[0] !== t) {
      t1 = t("discoverNewCollections");
      $[0] = t;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = itemViewGroup === "table" && "mt-[22px]";
    let t3;
    if ($[2] !== t2) {
      t3 = classNames(t2);
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t) {
      t4 = t("title");
      $[4] = t;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        Header: {
          className: "!top-0"
        },
        Skeleton: {
          className: "animate-none"
        }
      };
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== Comp) {
      t6 = <Comp overrides={t5} />;
      $[7] = Comp;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
      t7 = <EmptyStateStack description={t1} innerClassName={t3} showImageStack={false} title={t4}>{t6}</EmptyStateStack>;
      $[9] = t1;
      $[10] = t3;
      $[11] = t4;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    return t7;
  }
  let t1;
  if ($[14] !== hasSearchParams || $[15] !== onResetFilters || $[16] !== t) {
    t1 = hasSearchParams ? {
      title: t("title"),
      description: t("tryRemovingFilters"),
      cta: {
        label: t("clearFilters"),
        onClick: onResetFilters
      }
    } : {
      title: t("title"),
      description: t("discoverNewCollections"),
      cta: {
        label: t("goToDiscover"),
        href: "/"
      }
    };
    $[14] = hasSearchParams;
    $[15] = onResetFilters;
    $[16] = t;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  const props = t1;
  const t2 = !hasSearchParams;
  const t3 = itemViewGroup === "table" && "mt-[22px]";
  let t4;
  if ($[18] !== t3) {
    t4 = classNames(t3);
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      Header: {
        className: "!top-0"
      },
      Skeleton: {
        className: "animate-none"
      }
    };
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== Comp) {
    t6 = <Comp overrides={t5} />;
    $[21] = Comp;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== props || $[24] !== t2 || $[25] !== t4 || $[26] !== t6) {
    t7 = <EmptyStateStack showImageStack={t2} {...props} innerClassName={t4}>{t6}</EmptyStateStack>;
    $[23] = props;
    $[24] = t2;
    $[25] = t4;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}
function _temp(part) {
  return isSolanaAddress(part);
}